import './index.scss'
import React from 'react'
import Chart from 'react-apexcharts'
import text from './text.json'
import moment from 'moment'
import DateHelper from '../../../../utils/date'
import {colors} from '../../../../utils/colors'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const JobChart = ({statistics = [], name}) => {
    const TIME_EXTENSION = '00:00:00'
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const getCustomExtension = date => {
        if (date.includes(TIME_EXTENSION)) {
            return `[${TIME_EXTENSION}]`
        }
        return 'HH:mm:ss'
    }

    const fail = {
        name: text.fail,
        data: []
    }
    const run = {
        name: text.run,
        data: []
    }
    const tick = {
        name: text.tick,
        data: []
    }
    const complete = {
        name: text.complete,
        data: []
    }
    const dates = []

    statistics.forEach((item) => {
        const {
            tick_count: tickCount,
            complete_count: completeCount,
            run_count: runCount,
            fail_count: failCount,
            received_at: receivedAt
        } = item
        const date = DateHelper.convertToTimeZone(receivedAt)
        const customExtension = getCustomExtension(receivedAt)

        fail.data.push({
            x: date,
            y: failCount,
            date: moment(receivedAt).format(`DD/MM/YYYY, ${customExtension}`)
        })
        run.data.push({
            x: date,
            y: runCount
        })
        complete.data.push({
            x: date,
            y: completeCount
        })
        tick.data.push({
            x: date,
            y: tickCount
        })
        dates.push(date)
    })

    const series = [run, complete, fail, tick]
    const options = {
        fontFamily: 'SpaceGrotesk, sans-serif',
        colors: [colors.colorMediumBlue, colors.colorBlue, colors.colorMediumRed, isDarkMode ? colors.colorMuted : colors.colorBgFilter],
        chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
                show: true,
                export: {
                    csv: {
                        filename: `${name}`,
                        headerCategory: 'Received at',
                        dateFormatter(timestamp) {
                            return moment(timestamp).format('HH:mm / DD.MM.YYYY')
                        }
                    }
                }
            }
        },

        xaxis: {
            type: 'datetime',
            categories: dates,
            labels: {
                datetimeFormatter: {
                    year: 'yyyy',
                    month: 'MMM \'yy',
                    day: 'dd MMM',
                    hour: 'HH:mm'
                }
            }
        },
        grid: {
            show: true,
            row: {
                colors: ['transparent']
            },
            column: {
                colors: ['transparent']
            },
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }

            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '100%'

            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
        },

        fill: {
            opacity: 1
        },
        tooltip: {
            show: true,
            custom: function({dataPointIndex}) {
                const [run, complete, fail, tick] = series
                const date = fail.data[dataPointIndex].date
                return `<div class="chart-tooltip-container">
                     <span class="date">  ${date}   </span>
                     <div class="d-flex flex-column gap-half">
                     <span class="run">  ${text.run}   </span>
                     <span class="value">  ${run.data[dataPointIndex].y}  <span>
                     </div>
                     <div class="d-flex flex-column gap-half">
                     <span class="complete">  ${text.complete}   </span>
                     <span class="value">  ${complete.data[dataPointIndex].y}  <span>
                     </div>
                     <div class="d-flex flex-column gap-half">
                     <span class="fail">  ${text.fail}   </span>
                     <span class="value">  ${fail.data[dataPointIndex].y}  <span>
                     </div>
                     <div class="d-flex flex-column gap-half">
                     <span class="tick">  ${text.tick}   </span>
                     <span class="value">  ${tick.data[dataPointIndex].y}  <span>
                     </div>
                     </div>`
            },
            style: {
                fontSize: '12px',
                fontFamily: 'SpaceGrotesk, sans-serif'
            }

        }
    }

    return (
        <div className={classNames('job-chart-container', {
            dark: isDarkMode
        })}>
            <Chart options={options} series={series} type="bar" width={'100%'} height={286}/>
        </div>
    )
}
export default JobChart
